import React, { useContext, useEffect } from 'react';
import { topTitleContext } from '../../../contexts/TopTitle';

import AvatarMenu from '../AvatarMenu';
import { AssumingBox } from '..';
import TryNewVersionButton from '../TryNewVersionButton';

import { Container, Title } from './styles';

const TopBar: React.FC = () => {
    const { title, titleValue } = useContext(topTitleContext);

    useEffect(() => {
        if (!title) titleValue(title);
    }, [title]);

    return (
        <Container>
            <Title>{title}</Title>
            <AssumingBox />
            <TryNewVersionButton />
            <AvatarMenu />
        </Container>
    );
};

export default TopBar;
